export const hasToken = ({ token }) => !!token;
export const hasRole = ({ role }) => role;
export const hasGuiche = ({ guiche }) => guiche;
